import { render, staticRenderFns } from "./errorExam.vue?vue&type=template&id=77f46776&scoped=true"
import script from "./errorExam.vue?vue&type=script&lang=js"
export * from "./errorExam.vue?vue&type=script&lang=js"
import style0 from "./errorExam.vue?vue&type=style&index=0&id=77f46776&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f46776",
  null
  
)

export default component.exports